var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('header',{attrs:{"id":"hero"}},[_c('AppNavigation'),_c('LandingPage')],1),_c('main',[_c('About')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }